"use client";

import { createContext, ReactNode, useContext } from "react";
import { useDisclosure } from "@chakra-ui/react";

type DisclosureContextType = ReturnType<typeof useDisclosure> & {
  // Secondary disclosure to control nested modals without conflicting
  secondary: ReturnType<typeof useDisclosure>;
};

const DisclosureContext = createContext<DisclosureContextType>({
  isOpen: false,
  onOpen: () => undefined,
  onClose: () => undefined,
  onToggle: () => undefined,
  getButtonProps: () => ({}) as any,
  getDisclosureProps: () => ({}) as any,
  secondary: {
    isOpen: false,
    onOpen: () => undefined,
    onClose: () => undefined,
    onToggle: () => undefined,
    getButtonProps: () => ({}) as any,
    getDisclosureProps: () => ({}) as any,
  },
} as DisclosureContextType);

type DisclosureProviderProps = {
  children: ReactNode | ((props: DisclosureContextType) => ReactNode);
  isOpen?: boolean;
};

const DisclosureProvider = ({ children, isOpen }: DisclosureProviderProps) => {
  const primary = useDisclosure({
    isOpen,
  });
  const secondary = useDisclosure();

  return (
    <DisclosureContext.Provider value={{ ...primary, secondary }}>
      {typeof children === "function"
        ? children({ ...primary, secondary })
        : children}
    </DisclosureContext.Provider>
  );
};

export const useDisclosureContext = () => useContext(DisclosureContext);

export default DisclosureProvider;
